import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan} from "@fortawesome/pro-solid-svg-icons";

const FrameExtenderRadioGroup = ({ register, extenders, side }) => {
    const getExtenderAssetName = (name) => name.replace("35", "34");

    return (
        <>
            {extenders?.map((name) => (
                <div key={name} className="group">
                    <div
                        key={name}
                        className="relative flex flex-col items-center justify-center gap-2 group-has-[:checked]:bg-[#555454] p-3"
                    >
                        {name === 'none' ? (
                            <div className='h-20 w-full flex items-center justify-center'>
                                <FontAwesomeIcon className='w-full h-12 text-gray-600 group-has-[:checked]:text-white'
                                                 icon={faBan}/>
                            </div>
                        ): <div className='flex h-20 items-center justify-center'>
                            <img
                                className="size-14"
                                src={`/assets/extenders/${getExtenderAssetName(name)}.svg`}
                                alt={name}
                            />
                        </div>
                        }
                        <p className="text-gray-600 text-xs group-has-[:checked]:text-white">
                            {name.replace("_", " ")} {name !=='none' && "mm"}
                        </p>
                        <input
                            className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                            type="radio"
                            id="type"
                            value={name}
                            {...register(`${side}_frame_extender`)}
                        />
                    </div>
                </div>
            ))}
        </>
    );
};

export default FrameExtenderRadioGroup;
